import React, { useState, useEffect } from 'react';
import AddProfesion from './AddProfesion';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionProfesiones() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [profesiones, setProfesiones] = useState([]);
    const [editingProfesion, setEditingProfesion] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [profesionToDelete, setProfesionToDelete] = useState(null);
    const { user } = useUser();

    const fetchProfesiones = async () => {
        try {
            const response = await fetch(`${server}/MgProfesiones`);
            const data = await response.json();
            setProfesiones(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las profesiones: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchProfesiones();
    }, []);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (profesion) => {
        setProfesionToDelete(profesion);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setProfesionToDelete(null);
    };

    const handleNewProfesion = () => {
        fetchProfesiones();
        setEditingProfesion(null);
    };

    const handleDeleteProfesion = async () => {
        if (profesionToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                const response = await fetch(`${server}/MgProfesiones/${profesionToDelete.id}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchProfesiones();
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Profesión eliminada con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });                }
            } catch (error) {
           
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar la profesión: ' + error,
                });
            }
        }
    };

    const filteredProfesiones = profesiones.filter(profesion => profesion.descripcion.toLowerCase().includes(searchQuery.toLowerCase()));



    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">

                <br />
                <AddProfesion onNewProfesion={handleNewProfesion} editingProfesion={editingProfesion} />
                <div className="ln_solid" />

                <h2>Profesiones Existentes</h2>
                <div className="row">
                    <div className="col-md-6 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar profesión"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredProfesiones.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((profesion) => (
                                            <TableRow key={profesion.id}>
                                                <TableCell>{profesion.descripcion}</TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditingProfesion(profesion)} color="primary" disabled={!tienePermiso('Editar Profesión')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(profesion)} color="secondary" disabled={!tienePermiso('Eliminar Profesión')}>Eliminar</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredProfesiones.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar la profesión seleccionada?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteProfesion} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GestionProfesiones